module.exports = __webpack_public_path__ + "static/leader-step4.d262dedc.png";